export const handleChangeDataModalRating = (name, value) => ({
    type: 'CHANGE_DATA_MODAL_RATING', name, value
});